import { cn } from 'cn';
import { useId } from 'react';

export const CrosshatchFill = ({ className, style }: ComponentStyling) => {
  const patternId = useId();

  return (
    <svg
      className={cn(
        'absolute inset-0 size-full stroke-tiga-border-default/50',
        className,
      )}
      fill="none"
      style={style}
    >
      <defs>
        <pattern
          height="10"
          id={patternId}
          patternUnits="userSpaceOnUse"
          width="10"
          x="0"
          y="0"
        >
          <path d="M-3 13 15-5M-5 5l18-18M-1 21 17 3" />
        </pattern>
      </defs>
      <rect
        fill={`url(#${patternId})`}
        height="100%"
        stroke="none"
        width="100%"
      />
    </svg>
  );
};
